module.exports = __webpack_public_path__ + "img/newsImg3-17.e9ed2ea7.png";